import React, { useEffect, useState, useMemo } from "react";
import { Typography, Card, Row, Col, Spin } from "antd";
import { Column, Pie } from "@ant-design/charts";
import axios from "axios";
import Cookies from "js-cookie";
import { firebaseAPI } from "../firebaseConfig";

const { Title } = Typography;

const OverviewPage = () => {
  const [participantsData, setParticipants] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchParticipants = async () => {
      try {
        setIsLoading(true);
        setError(null);
        let token = Cookies.get("token") || "";
        // const response = await axiosInstance.get(
        //   `${firebaseAPI}/users/participants`,
        //   {
        //     headers: {
        //       Authorization: `Bearer ${token}`,
        //     },
        //   }
        // );
        // setParticipants(response.data);
      } catch (err) {
        console.error("Error:", err);
        setError("Failed to load participant data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchParticipants();
  }, []);

  const normalizeName = (name) => {
    if (typeof name === "string") {
      return name.toLowerCase();
    }
    return name;
  };

  const countData = (data, key) => {
    return data.reduce((acc, item) => {
      const normalizedKey = normalizeName(item[key]);
      if (normalizedKey) {
        acc[normalizedKey] = (acc[normalizedKey] || 0) + 1;
      }
      return acc;
    }, {});
  };

  const createChartData = (countedData) => {
    return Object.entries(countedData).map(([name, count]) => ({
      name,
      count,
    }));
  };

  // Memoize calculations to prevent unnecessary recomputations
  const { graduationYearsChartData, universitiesChartData, majorsChartData } =
    useMemo(() => {
      const emptyResult = {
        graduationYearsChartData: [],
        universitiesChartData: [],
        majorsChartData: [],
      };

      if (!participantsData.length) return emptyResult;

      return {
        graduationYearsChartData: createChartData(
          countData(participantsData, "gradYear")
        ),
        universitiesChartData: createChartData(
          countData(participantsData, "university")
        ),
        majorsChartData: createChartData(countData(participantsData, "major")),
      };
    }, [participantsData]);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <Title level={2}>Error</Title>
        <p>{error}</p>
      </div>
    );
  }

  const renderChartOrMessage = (chartData, message) => {
    return chartData.length > 0 ? (
      <Pie data={chartData} colorField="name" angleField="count" />
    ) : (
      <div style={{ textAlign: "center", padding: "20px" }}>{message}</div>
    );
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title level={2} style={{ textAlign: "center", marginBottom: "20px" }}>
        Overview Page
      </Title>

      <Row gutter={[16, 16]} justify="space-around">
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <Card>
            <Title level={3}>Graduation Years</Title>
            {graduationYearsChartData.length > 0 ? (
              <Column
                data={graduationYearsChartData}
                xField="name"
                yField="count"
              />
            ) : (
              <div style={{ textAlign: "center", padding: "20px" }}>
                No graduation year data available
              </div>
            )}
          </Card>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <Card>
            <Title level={3}>Universities</Title>
            {renderChartOrMessage(
              universitiesChartData,
              "No university data available"
            )}
          </Card>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <Card>
            <Title level={3}>Majors</Title>
            {renderChartOrMessage(majorsChartData, "No major data available")}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default OverviewPage;
